/**
 * HTTP layer for product inventory. On-hand stock records per product.
 *
 * Contains:
 * - fetchProductInventories / fetchProductInventory: reads
 * - postProductInventory / patchProductInventory / deleteProductInventory: writes
 */
import apiClient from '@sophocles/http-common';

const PRODUCT_INVENTORY_ENDPOINT = '/warehouse/product-inventories';

export const fetchProductInventories = queryParams =>
  apiClient.get(`${PRODUCT_INVENTORY_ENDPOINT}/`, { params: queryParams }).then(res => res.data);

export const fetchProductInventory = productInventoryId =>
  apiClient.get(`${PRODUCT_INVENTORY_ENDPOINT}/${productInventoryId}/`).then(res => res.data);

export const postProductInventory = data =>
  apiClient.post(`${PRODUCT_INVENTORY_ENDPOINT}/`, data).then(res => res.data);

export const patchProductInventory = (productInventoryId, data) =>
  apiClient.patch(`${PRODUCT_INVENTORY_ENDPOINT}/${productInventoryId}/`, data).then(res => res.data);

export const deleteProductInventory = productInventoryId =>
  apiClient.delete(`${PRODUCT_INVENTORY_ENDPOINT}/${productInventoryId}/`);
